import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { DateTime } from 'luxon';
import { Publishment } from '../db/Publishment.js';

export const createPublishment = registerQuery({
  type: () => Publishment,
  operationName: 'createPublishment',
  resolve: (entityID: string, from?: DateTime, till?: DateTime) => {
    return async (gqlFields: BaseQLSelectionSet<Publishment>) => {
      const publishment = new Publishment({ entityID, from: from?.toJSDate(), till: till?.toJSDate() });
      const publishmentID = await publishment.create();
      publishment._id = publishmentID;
      return publishment;
    };
  },
  params: [
    { name: 'entityID', type: () => String },
    { name: 'from', type: () => DateTime },
    { name: 'till', type: () => DateTime },
  ],
});
